/**
 * @file 设备
 * @author ss
 */

import Cookie from '@/utils/Cookie';

const Device = {
  getId(key) {
    const cookieName = key || 'deviceid';
    let token = Cookie.get(cookieName);
    if (!token) {
      const date = +new Date();
      const random = `${Math.random()}`;
      token = `h5_${date}${random.replace(/\./, '')}`;
    }
    return token;
  },
  getCacheId(key) {
    const cookieName = key || 'deviceId';
    let deviceId = window.localStorage.getItem(cookieName);
    if (!deviceId) {
      const date = +new Date();
      const random = `${Math.random()}`;
      deviceId = `h5_${date}${random.replace(/\./, '')}`;
      window.localStorage.setItem(cookieName, deviceId);
    }
    return deviceId;
  },

  getDeviceId() {
    const date = +new Date();
    const random = `${Math.random()}`;
    const token = `h5_${date}${random.replace(/\./, '')}`;
    return token;
  },
};

export default Device;



// WEBPACK FOOTER //
// ./src/utils/Device/index.js